import { createContext, Dispatch } from "react"
import { initialBreadcrumbsState } from "./reducer"
import { BreadcrumbsState, BreadcrumbsAction } from "./types"

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const BreadcrumbsContext = createContext<[BreadcrumbsState, Dispatch<BreadcrumbsAction>]>([initialBreadcrumbsState, () => {}])
